{
  "actionbar.actions": "Åtgärder",
  "actionbar.actionsAvailable": "Åtgärder finns.",
  "actionbar.clearSelection": "Rensa markering",
  "actionbar.selected": "{count, plural, =0 {Inga valda} one {# vald} other {# valda}}",
  "actionbar.selectedAll": "Alla markerade",
  "button.pending": "väntande",
  "calendar.invalidSelection": "{selectedCount, plural, one {Valt datum är inte tillgängligt.} other {Valda datum är inte tillgängliga.}}",
  "contextualhelp.help": "Hjälp",
  "contextualhelp.info": "Information",
  "datepicker.endTime": "Sluttid",
  "datepicker.startTime": "Starttid",
  "datepicker.time": "Tid",
  "dialog.alert": "Varning",
  "dialog.dismiss": "Avvisa",
  "dropzone.replaceMessage": "Släpp filen för att ersätta",
  "inlinealert.informative": "Information",
  "inlinealert.negative": "Fel",
  "inlinealert.notice": "Varning",
  "inlinealert.positive": "Lyckades",
  "label.(optional)": "(valfritt)",
  "label.(required)": "(krävs)",
  "menu.moreActions": "Fler åtgärder",
  "picker.placeholder": "Välj…",
  "slider.maximum": "Maximum",
  "slider.minimum": "Minimum",
  "table.loading": "Läser in...",
  "table.loadingMore": "Läser in mer...",
  "table.resizeColumn": "Ändra storlek på kolumn",
  "table.sortAscending": "Sortera i stigande ordning",
  "table.sortDescending": "Sortera i fallande ordning",
  "tag.actions": "Åtgärder",
  "tag.hideButtonLabel": "Visa mindre",
  "tag.noTags": "Ingen",
  "tag.showAllButtonLabel": "Visa alla ({tagCount, number})",
  "breadcrumbs.more": "Fler artiklar",
  "combobox.noResults": "Inga resultat",
  "notificationbadge.indicatorOnly": "Ny aktivitet",
  "notificationbadge.plus": "{notifications}+",
  "toast.clearAll": "Clear all",
  "toast.collapse": "Collapse",
  "toast.showAll": "Show all"
}